"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('circular-connection', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M29 9C29 9.24831 28.9819 9.49239 28.9469 9.73099C28.5932 12.1459 26.5131 14 24 14C21.4869 14 19.4068 12.1459 19.0531 9.73099C19.0181 9.49239 19 9.24831 19 9C19 6.23858 21.2386 4 24 4C26.7614 4 29 6.23858 29 9Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M15 36C15 37.3416 14.4716 38.5597 13.6117 39.4577C12.7015 40.4082 11.4199 41 10 41C7.23858 41 5 38.7614 5 36C5 33.9899 6.18614 32.2569 7.89667 31.4626C8.53604 31.1657 9.24867 31 10 31C12.7614 31 15 33.2386 15 36Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M43 36C43 38.7614 40.7614 41 38 41C36.5801 41 35.2985 40.4082 34.3883 39.4577C33.5284 38.5597 33 37.3416 33 36C33 33.2386 35.2386 31 38 31C38.7513 31 39.464 31.1657 40.1033 31.4626C41.8139 32.2569 43 33.9899 43 36Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M10 31C12.7614 31 15 33.2386 15 36C15 37.3416 14.4716 38.5597 13.6117 39.4577C16.4845 41.6786 20.0879 43 24 43C27.9121 43 31.5155 41.6786 34.3883 39.4577C33.5284 38.5597 33 37.3416 33 36C33 33.2386 35.2386 31 38 31C38.7513 31 39.464 31.1657 40.1033 31.4626C40.6847 29.7482 41 27.9109 41 26C41 18.3318 35.9229 11.8494 28.9469 9.73099C28.5932 12.1459 26.5131 14 24 14C21.4869 14 19.4068 12.1459 19.0531 9.73099C12.0771 11.8494 7 18.3318 7 26C7 27.9109 7.31528 29.7482 7.89667 31.4626C8.53604 31.1657 9.24867 31 10 31Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M40.1033 31.4626C39.464 31.1657 38.7513 31 38 31C35.2386 31 33 33.2386 33 36C33 37.3416 33.5284 38.5597 34.3883 39.4577M40.1033 31.4626C41.8139 32.2569 43 33.9899 43 36C43 38.7614 40.7614 41 38 41C36.5801 41 35.2985 40.4082 34.3883 39.4577M40.1033 31.4626C40.6847 29.7482 41 27.9109 41 26C41 18.3318 35.9229 11.8494 28.9469 9.73099M34.3883 39.4577C31.5155 41.6786 27.9121 43 24 43C20.0879 43 16.4845 41.6786 13.6117 39.4577M13.6117 39.4577C14.4716 38.5597 15 37.3416 15 36C15 33.2386 12.7614 31 10 31C9.24867 31 8.53604 31.1657 7.89667 31.4626M13.6117 39.4577C12.7015 40.4082 11.4199 41 10 41C7.23858 41 5 38.7614 5 36C5 33.9899 6.18614 32.2569 7.89667 31.4626M7.89667 31.4626C7.31528 29.7482 7 27.9109 7 26C7 18.3318 12.0771 11.8494 19.0531 9.73099M19.0531 9.73099C19.4068 12.1459 21.4869 14 24 14C26.5131 14 28.5932 12.1459 28.9469 9.73099M19.0531 9.73099C19.0181 9.49239 19 9.24831 19 9C19 6.23858 21.2386 4 24 4C26.7614 4 29 6.23858 29 9C29 9.24831 28.9819 9.49239 28.9469 9.73099",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;